import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SendIcon from './icons/SendIcon';
import FileIcon from './icons/FileIcon';
import PopupWindow from './popups/PopupWindow';
import UserPopupWindow from './popups/UserPopupWindow';
import EmojiPicker from './emoji-picker/EmojiPicker';
import UserPicker from './user-list/UserPicker';
import draftToHtml from 'draftjs-to-html';
import {
  Card, Row, Input, Col, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown, Modal, ModalHeader,
  ModalBody, Button, CardBody, FormGroup, Table
} from 'reactstrap';
import { EditorState, convertToRaw, ContentState, AtomicBlockUtils, Modifier } from 'draft-js';
import Editor from 'draft-js-plugins-editor';
import createMentionPlugin, { defaultSuggestionsFilter } from 'draft-js-mention-plugin';
import createToolbarPlugin from 'draft-js-static-toolbar-plugin';
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
} from 'draft-js-buttons';
import createLinkifyPlugin from 'draft-js-linkify-plugin';
import createEmojiPlugin from 'draft-js-emoji-plugin';
import createImagePlugin from 'draft-js-image-plugin';

import { mediaBlockRenderer } from "./entities/mediaBlockRenderer";

import { fromJS } from 'immutable'

import 'draft-js-mention-plugin/lib/plugin.css';
import 'draft-js-static-toolbar-plugin/lib/plugin.css';
import 'draft-js-linkify-plugin/lib/plugin.css';
import 'draft-js-emoji-plugin/lib/plugin.css';
import editorStyles from './editorStyles.css';
import 'draft-js-image-plugin/lib/plugin.css';
import profileIcon from '../../assets/img/proicon.png';
import __get_users from './user-list/userdata';
// import __get_projects from './project-list/projectdata';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import ProjectService from './../../services/api/Project';
import RunService from './../../services/api/Run';
import ClusterService from './../../services/api/Cluster';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { uuidv4 } from '../../components/Notebook/operations/notebook'


registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize, FilePondPluginFileEncode);
class HeadlinesPicker extends Component {
  componentDidMount() {
    setTimeout(() => { window.addEventListener('click', this.onWindowClick); });
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  }

  onWindowClick = () =>
    // Call `onOverrideContent` again with `undefined`
    // so the toolbar can show its regular content again.
    this.props.onOverrideContent(undefined);

  render() {
    const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton];
    return (
      <div>
        {buttons.map((Button, i) => // eslint-disable-next-line
          <Button key={i} {...this.props} />
        )}
      </div>
    );
  }
}

const imagePlugin = createImagePlugin();
const toolbarPlugin = createToolbarPlugin();
const { Toolbar } = toolbarPlugin;
let mentions = [];
const mentionsJob = [];
const mentionsProject = [];
export const jobidLoad = (runs) => {
  mentionsJob.length = 0;
  var i = 0;
  for (i = 0; i < runs.length; i++) {
    if (runs[i].sourceId !== null && runs[i].jobId !== null) {
      mentionsJob.push({ name: runs[i].jobId.toString() })
    }
  }
}

export const projectLoad = (users) => {
  if (users !== null) {
    mentionsProject.length = 0;
    for (const project of users) {
      mentionsProject.push({ name: project.name.toString(), id: project.id === null ? null : project.id.toString() })
    }
  }
}

const linkifyPlugin = createLinkifyPlugin();
const emojiPlugin = createEmojiPlugin();

const positionSuggestions = (settings) => {
  return {
    left: settings.decoratorRect.left + 'px',
    top: settings.decoratorRect.top - 15 + 'px', // change this value (40) for manage the distance between cursor and bottom edge of popover
    display: 'block',
    position: "fixed",
    transform: 'scale(1) translateY(-100%)', // transition popover on the value of its height
    transformOrigin: '1em 0% 0px',
    transition: 'all 0.25s cubic-bezier(0.3, 1.2, 0.2, 1)'
  };
}
const Entry = (props) => {
  const {
    theme,
    onClick,
    mention,
    id,
    searchValue, // eslint-disable-line no-unused-vars
    isFocused, // eslint-disable-line no-unused-vars
    ...parentProps
  } = props;
  return (
    <div {...parentProps} id={id}>
      <div className={theme.mentionSuggestionsEntryContainer}>
        <div className={theme.mentionSuggestionsEntryContainerLeft}  >
          <img
            src={mention.avatar}
            alt="avatarphoto"
            className={theme.mentionSuggestionsEntryAvatar}
            style={{ width: '30px', height: '30px' }}
            role="presentation"
          /> &nbsp;&nbsp; {mention.name}
          <span style={{ display: 'none' }}>{mention.emailid}</span>
        </div>
      </div>
    </div>
  );
};
const Entryjob = (props) => {
  const {
    mention,
    theme,
    searchValue, // eslint-disable-line no-unused-vars
    isFocused, // eslint-disable-line no-unused-vars
    ...parentProps
  } = props;

  return (
    <div {...parentProps}>
      <div className={theme.mentionSuggestionsEntryContainer}>
        <div className={theme.mentionSuggestionsEntryContainerLeft}>
          ## &nbsp;&nbsp; {mention.name}
          {/*<span style={{display:'none'}}>{mention.id}</span>*/}
        </div>
      </div>
    </div>
  );
};


const EntryProject = (props) => {
  const {
    mention,
    theme,
    searchValue, // eslint-disable-line no-unused-vars
    isFocused, // eslint-disable-line no-unused-vars
    ...parentProps
  } = props;

  return (
    <div {...parentProps}>
      <div className={theme.mentionSuggestionsEntryContainer}>
        <div className={theme.mentionSuggestionsEntryContainerLeft}>
          # &nbsp;&nbsp; {mention.name}
          <span style={{ display: 'none' }}>{mention.id}</span>
        </div>
      </div>
    </div>
  );
};

const EntryProjectConfig = (props) => {
  const {
    mention,
    theme,
    searchValue, // eslint-disable-line no-unused-vars
    isFocused, // eslint-disable-line no-unused-vars
    ...parentProps
  } = props;

  return (
    <div {...parentProps}>
      <div className={theme.mentionSuggestionsEntryContainer}>
        <div className={theme.mentionSuggestionsEntryContainerLeft}>
          / &nbsp;&nbsp; {mention.name}
          {/*<Button>Rerun</Button>*/}
          <span style={{ display: 'none' }}>{mention.id}</span>
        </div>
      </div>
    </div>
  );
};

class UserInput extends Component {

  constructor(props) {
    super(props);
    this.mentionPlugin = createMentionPlugin({ mentionPrefix: '@', mentionTrigger: '@', positionSuggestions });  // user list
    this.mentionPlugin2 = createMentionPlugin({ mentionPrefix: '##', mentionTrigger: '##', positionSuggestions });  // job id list
    this.mentionPlugin3 = createMentionPlugin({ mentionPrefix: '#', mentionTrigger: '#', positionSuggestions });   // project list
    this.mentionPlugin4 = createMentionPlugin({ mentionPrefix: '/', mentionTrigger: '/', positionSuggestions });   // project config
    this.state = {
      inputActive: false,
      inputHasText: false,
      emojiPickerIsOpen: false,
      userPickerIsOpen: false,
      emojiFilter: '',
      userFilter: '',
      userInputfilter: '',
      input_userEmail: [],
      editorState: EditorState.createEmpty(),
      oldEditorState: EditorState.createEmpty(),
      editorCount: 0,
      suggestions: fromJS([]),
      mentionList1: mentions,
      mentionList2: mentionsJob,
      mentionList3: mentionsProject,
      mentionList4: [],
      projectName: "",
      projectId: "",
      mentionsConfig: [],
      hasFocus: false,
      chatsendmail: [],
      projectDTO: [],
      hideProjectPopup: false,
      projectParameter: '',
      flagMode: "",
      masterJobId: null,
      viewProjecturl: "",
      files: [],
      base64Data: "",
      flagEditor: false,
      clusterK8sDTOS: [],
      SelectedClusterId: "",
      SelectedClusterName: "",
      jobPageNumber: 0,
      parametersTablesdata: [],
      detailedView_ParamSet: "",
      deleteParameter: false,
      newparameterset: ''

    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }
  componentDidMount() {
    this.emojiPickerButton = document.querySelector('#sc-emoji-picker-button');
    this.GetAllClusters();
  }

  handleScrollRuns = (e) => {
    e.preventDefault()
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      this.setState((preState) => {
        return { jobPageNumber: preState.jobPageNumber + 1 };
      }, () => {
        // console.log(this.state.jobPageNumber)
        this.GetRunsData();
      });
    }
  }


  GetRunsData = () => {
    let postData = {
      projectId: null
    }
    RunService.getRunbySize(postData, this.state.jobPageNumber, 10).then((response) => {
      if (response !== "") {
        if (response.status === 'SUCCESS') {
          let newJobs = response.runDetails.content
          for (var i = 0; i < newJobs.length; i++) {
            mentionsJob.push({ "name": newJobs[i].jobId.toString() })
          }
          this.setState({
            mentionList2: mentionsJob
          })
          // console.log(this.state.mentionList2)
        } else {
          toast.error(response.errorMessage);
        }
      }
    });
  }

  componentWillMount() {
    __get_users(users => {
      mentions = [];
      var i = 0;
      for (i = 0; i < users.length; i++) {
        mentions.push({
          name: users[i].firstName + " " + users[i].lastName,
          avatar: users[i].photoURL === null ? profileIcon : users[i].photoURL,
          emailid: users[i].email,
          id: users[i].id
        })
      }
    });
  }

  onURLChange = e => this.setState({ urlValue: e.target.value });
  onAddImage = e => {
    e.preventDefault();
    const editorState = this.state.editorState;
    const urlValue = window.prompt("Paste Image Link");
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      "image",
      "IMMUTABLE",
      { src: urlValue }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(
      editorState,
      { currentContent: contentStateWithEntity },
      "create-entity"
    );
    this.setState(
      {
        editorState: AtomicBlockUtils.insertAtomicBlock(
          newEditorState,
          entityKey,
          " "
        )
      },
      // () => {
      //   setTimeout(() => this.focus(), 0);
      // }
    );
  };


  handleInit() {
    // console.log("FilePond instance has initialised", this.pond);
  }

  ProceedPasteImage = () => {
    // console.log(this.state.base64Data);
    const base64 = `data:image/jpeg;base64,${this.state.base64Data}`;
    const newEditorState = this.insertImage(this.state.editorState, base64);
    this.setState({ editorState: newEditorState });
    this.toggleUpload();
  }

  insertImage = (editorState, base64) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      'image',
      'IMMUTABLE',
      { src: base64 },
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(
      editorState,
      { currentContent: contentStateWithEntity },
    );
    return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ');
  };

  onChange = (editorState) => {
    var getcurrentText = editorState.getCurrentContent().getPlainText();
    if (getcurrentText === "") {
      this.setState({
        mentionsConfig: [],
        mentionList4: []
      })
    }
    this.setState({
      editorState,
    });
  };
  toggleUpload = () => {
    if (this.state.showUploadModal) {
      this.setState({ showUploadModal: false })
    } else {
      this.setState({ showUploadModal: true })
    }
  }

  EditorClick = () => {
    if (this.state.flagEditor) {
      this.toggleConfig()
    }
  }
  toggleConfig = () => {
    if (this.state.showConfigModal) {
      this.setState({ showConfigModal: false })
    } else {
      this.setState({ showConfigModal: true })
    }
  }

  customSuggestionsFilter = (searchValue, suggestions) => {
    // console.log(searchValue)

    const size = (list) => (list.constructor.name === 'List'
      ? list.size
      : list.length);

    const get = (obj, attr) => (obj.get
      ? obj.get(attr)
      : obj[attr]);

    const value = searchValue.toLowerCase();
    //     const filteredSuggestions = suggestions.filter((suggestion) => (
    //   !value || get(suggestion,'name').toLowerCase().indexOf(value) > -1
    // ));

    const filteredSuggestions = suggestions.filter(f => get(f, 'name').toLowerCase().startsWith(value));
    const length = size(filteredSuggestions) < suggestions.length ? size(filteredSuggestions) : suggestions.length;
    return filteredSuggestions.slice(0, length);

  };

  onSearchChange = ({ value }) => {
    this.setState({
      mentionList1: this.customSuggestionsFilter(value, mentions),
    });
  };

  onSearchChange2 = ({ value }) => {
    this.setState({
      mentionList2: this.customSuggestionsFilter(value, mentionsJob),
    });
  };

  onSearchChange3 = ({ value }) => {
    this.setState({
      mentionList3: this.customSuggestionsFilter(value, mentionsProject),
    });
  };

  onSearchChange4 = ({ value }) => {
    this.setState({
      mentionList4: defaultSuggestionsFilter(value, this.state.mentionsConfig),
    });
  };
  ConstructParameterTable = (detailedView) => {
    let appendParamTable = "";
    for (var i = 0; i < detailedView.length; i++) {
      if (detailedView[i].key === null && detailedView[i].row === false) {
        appendParamTable = appendParamTable + detailedView[i].value + "\n";
      }
      else {
        appendParamTable = appendParamTable + detailedView[i].key + "=" + detailedView[i].value + "\n";
      }
    }
    this.setState({
      detailedView_ParamSet: appendParamTable,
      parameterSet: appendParamTable
    })
  }

  handleChangeDetailedparam = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.state.projectParameter = event.target.value;
    this.state.detailedView_ParamSet = event.target.value;
    this.setState({ [name]: value });
    let newpara = this.state.detailedView_ParamSet
    RunService.getParaTable(newpara)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let parametersTables_array = []
          let parametersTables_files = response.parameterTables
          if (parametersTables_files !== null) {
            for (let index = 0; index < parametersTables_files.length; index++) {
              parametersTables_array.push(parametersTables_files[index])
            }
            this.setState({
              parametersTablesdata: parametersTables_array
            });
          }
          else {
            this.setState({
              parametersTablesdata: []
            });
          }
        }
      })
  }

  handleChangeparam(index, dataType, value) {
    let newState = this.state.parametersTablesdata.map((item, i) => {
      if (i === index) {
        return { ...item, [dataType]: value };
      }
      return item;
    });
    this.setState({
      parametersTablesdata: newState
    });
    this.ConstructParameterTable(newState)
  }
  Submitrerun = (e) => {
    this.toggleConfig();  // To close the config popup
    let currentUrl = window.location.origin;
    let redirectUrl = currentUrl + "/viewProject/";
    let runurl = redirectUrl + this.state.projectDTO[0].id;
    // this.state.viewProjecturl = runurl;
    //this.state.hasFocus = true;
    this.setState({ viewProjecturl: runurl, hasFocus: true })
    // console.log(this.state.editorState.getCurrentContent().getPlainText())
    if (this.state.editorCount === 0) {
      this.setState({ oldEditorState: this.state.editorState, editorCount: 1 }, () => {
        this._insertParamText();
      })
    } else {
      this._insertParamText();
    }
    // this.RunPorject(e);
    // window.open(runurl, "_blank") 
  }

  ConfirmSubmitJob = () => {
    confirmAlert({
      title: 'New Job',
      message: 'Are you sure to run this Project - ' + this.state.projectName + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.RunPorject()
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  RunPorject = () => {
    // this.handleSubmit(e);
    this.handleEnterKeyAction();
    let cName;
    let cId;
    // alert(this.state.SelectedClusterId)
    if (this.state.SelectedClusterId !== "") {
      cName = this.state.SelectedClusterName;
      cId = this.state.SelectedClusterId;
    } else {
      cName = this.state.projectDTO[0].clusterName;
      if (cName === "Small" || cName === "Medium" || cName === "Large" || cName === "GPU") {
        cId = null;
      } else {
        cId = this.state.projectDTO[0].clusterId;
      }
    }

    let post = {
      clusterName: cName,
      kernelName: this.state.projectDTO[0].kernelName,
      description: this.state.projectDTO[0].description,
      id: this.state.projectDTO[0].id,
      clusterId: cId,
      kernelId: this.state.projectDTO[0].kernelId,
      // clusterId:((this.state.projectDTO[0].clusterId==undefined || this.state.projectDTO[0].clusterId=="undefined")?null:this.state.projectDTO[0].clusterId),
      masterJobId: this.state.projectDTO[0].id,
      outputFileDelimiter: this.state.projectDTO[0].outputFileDelimiter,
      modelCodeFiles: this.state.projectDTO[0].modelCodeFiles,
      modelInputFiles: this.state.projectDTO[0].modelInputFiles,
      modelCodeFolders: this.state.projectDTO[0].modelCodeFolders,
      modelInputFolders: this.state.projectDTO[0].modelInputFolders,
      recentInputRunDTO: null,
      recentCodeRunDTO: null,
      name: this.state.projectDTO[0].name,
      inputCodeFilesRequired: this.state.projectDTO[0].inputCodeFilesRequired,
      inputFilesRequired: this.state.projectDTO[0].inputFilesRequired,
      // parameterSet: this.state.parameterSet,
      parameterSet: this.state.projectParameter,
      libraries: this.state.projectDTO[0].libraries
    }

    if (this.state.flagMode === "job") {
      var newKey = "masterJobId";
      var newVal = this.state.masterJobId;
      post[newKey] = newVal;
    }
    // console.log(JSON.stringify(post))
    RunService.PostRerun(post)
      .then((response) => {
        //console.log(JSON.stringify(response))
        if (response.status === 'SUCCESS') {
          toast.success("New Job created successfully.");
          this.setState({ loading: false });
        } else {
          toast.error(response.errorMessage);
        }
      });
  }

  GetAllClusters = () => {
    ClusterService.getAllClusters()
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.k8sDTOPage.content !== null) {
            let clusterdetails = response.k8sDTOPage.content.filter(item => item.clusterStatus === "RUNNING")
            this.setState({
              clusterK8sDTOS: clusterdetails
            });
          }
        } else {
          toast.error(response.errorMessage);
        }
      })
  }

  // focus = () => {
  //   this.editor.focus();
  // };
  onAddMention = (value) => {
    // this.setState({chatsendmail:value})
    this.setState({
      chatsendmail: value
    }, () => {
      let myappendUser = this.state.chatsendmail;
      let selectedEmail = { user: myappendUser, email: this.state.chatsendmail.emailid };
      this.setState({
        input_userEmail: [...this.state.input_userEmail, selectedEmail], mentionList4: [], mentionsConfig: []
      });
    })
    //  this.state.chatsendmail = value;
  }

  AddConfigData = () => {
    this.state.mentionsConfig = [];
    this.state.projectDTO = [];
    this.state.mentionsConfig.push(
      {
        name: "Param"
      },
      {
        name: "Cluster"
      });
    return this.state.mentionsConfig;
  }


  onAddMentionProject = (value) => {
    this.setState({ mentionList4: this.AddConfigData(), projectId: value.id, projectName: value.name, flagMode: "project" })
  }

  onAddMentionJob = (value) => {
    this.setState({ mentionList4: this.AddConfigData(), projectId: parseInt(value.name), flagMode: "job" }) // here value.name is job id
  }

  onAddMentionConfig = (value) => {
    // alert(JSON.stringify(value))
    this.state.flagMode === "project" ? this.getProjectById(this.state.projectId) : this.getProjectByJobId(this.state.projectId)
    if (value.name === "Cluster") {
      this.setState({ mentionsConfig: this.state.clusterK8sDTOS })
      //  this.state.mentionsConfig = [];
      //  this.state.mentionsConfig = this.state.clusterK8sDTOS;
    } else if (value.name === "Param") {
      this.setState({ showConfigModal: true, projectParameter: "" })
    } else {
      // execute this part after select cluster name
      let currentUrl = window.location.origin;
      let redirectUrl = currentUrl + "/viewProject/";
      try {
        let pid = this.state.flagMode === "project" ? this.state.projectDTO[0].id : this.state.projectDTO.masterJobId;
        let runurl = redirectUrl + pid;
        // let runurl = redirectUrl+this.state.projectDTO[0].id;
        // this.state.viewProjecturl = runurl;
        // this.state.hasFocus = true;

        this.setState({
          viewProjecturl: runurl,
          hasFocus: true,
          SelectedClusterId: value.id,
          SelectedClusterName: value.name
        })
      } catch (err) {
        // console.log("id undefined")
      }
    }
  }

  removeEditorText() {
    const txt = ''
    const contentState = ContentState.createFromText(txt);
    const editorState = EditorState.push(this.state.editorState, contentState);
    this.setState({ editorState });
  }

  _insertParamText() {
    this.removeEditorText()
    const editorState = this.state.oldEditorState;
    const selection = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    const ncs = Modifier.insertText(contentState, selection, document.getElementById("textAreaParam").value);
    const es = EditorState.push(editorState, ncs, 'insert-fragment');
    this.setState({
      editorState: es,
      flagEditor: true
    });
  }


  showconfigParam = () => {
    this.setState({
      showConfigModal: true
    })
  }
  handleKeyPress(event) {
    if (event.key === '@') {
      event.preventDefault();
      if (!this.state.userPickerIsOpen) {
        this.setState({ userPickerIsOpen: true, userInputfilter: '' }, () => {
          this._renderUserPopup();
        });
      }

    } else {
      this.setState({
        userInputfilter: this.userInput.textContent
      })
    }
  }

  getProjectById = (id) => {
    ProjectService.GetProjectById(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let parametersTables_array = []
          let parametersTables_files = response.projectDTOS[0].parametersTables
          if (response.projectDTOS[0].parametersTables.length > 0) {
            for (let index = 0; index < parametersTables_files.length; index++) {
              parametersTables_array.push(parametersTables_files[index])
            }
            // console.log('parametersTables_array', parametersTables_array)
            this.setState({
              parametersTablesdata: parametersTables_array
            });
          }
          else {
            this.setState({
              parametersTablesdata: []
            });
          }
          this.setState({
            projectDTO: response.projectDTOS,
            projectParameter: response.projectDTOS[0].parameterSet,
            parametersTables: parametersTables_array
          })
          this.ConstructParameterTable(parametersTables_array)
        }
      });
  }

  getProjectByJobId = (id) => {
    RunService.GetJobRun(id)
      .then((response) => {
        let DTO = [];
        let parametersTables_array = []
        let parametersTables_files = response.parametersTables
        if (response.parametersTables !== null) {
          for (let index = 0; index < parametersTables_files.length; index++) {
            parametersTables_array.push(parametersTables_files[index])
          }
          this.setState({
            parametersTablesdata: parametersTables_array
          });
        }
        else {
          this.setState({
            parametersTablesdata: []
          });
        }

        DTO.push(response);

        this.setState({
          projectDTO: DTO,
          projectParameter: response.parameterSet,
          projectName: response.name,
          masterJobId: response.masterJobId,
          parametersTablesdata: this.state.parametersTablesdata
        })
        this.ConstructParameterTable(parametersTables_array)

      });
  }

  handleKeyUp(event) {
    const inputHasText = event.target.innerHTML.length !== 0 &&
      event.target.innerText !== '\n';
    this.setState({ inputHasText });
  }
  _showFilePicker() {
    // this._fileUploadButton.click();
  }
  toggleEmojiPicker = (e) => {
    e.preventDefault();
    if (!this.state.emojiPickerIsOpen) {
      this.setState({ emojiPickerIsOpen: true });
    }
  }
  closeEmojiPicker = (e) => {
    if (this.emojiPickerButton.contains(e.target)) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.setState({ emojiPickerIsOpen: false });
  }

  closeUserPicker = (e) => {
    if (this.emojiPickerButton.contains(e.target)) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.setState({ userPickerIsOpen: false });

  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
  onEditorStateChange = (editorState) => {
    this.setState({
      editorState
    });
  }

  _onFilesSelected(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.props.onFilesSelected(event.target.files);
    }
  }

  _handleEmojiPicked = (emoji) => {
    this.setState({ emojiPickerIsOpen: false });
    if (this.state.inputHasText) {
      this.userInput.innerHTML += emoji;
    } else {
      this.props.onSubmit({
        author: 'me',
        type: 'emoji',
        data: emoji
      });
    }
  }

  _handleUserPicked = (first, last, email) => {
    let myappendUser = "<u>@" + first + " " + last + ",</u> "
    let selectedEmail = { user: myappendUser, email: email };
    // const filteredArray = this.state.UserList.filter((res) => res.firstName !== firstName);
    this.setState({
      userPickerIsOpen: false,
      input_userEmail: [...this.state.input_userEmail, selectedEmail],
    });
    // if (!this.state.inputHasText) {
    this.userInput.innerHTML += myappendUser
    // } else {
    // this.props.onSubmit({
    //   author: 'me',
    //   type: 'text',
    //   data: first
    // });
    // }
  }

  handleEmojiFilterChange = (event) => {
    const emojiFilter = event.target.value;
    this.setState({ emojiFilter });
  }

  handleUserFilterChange = (event) => {
    const userFilter = event.target.value;
    this.setState({ userFilter });
  }

  _renderEmojiPopup = () => (
    <PopupWindow
      isOpen={this.state.emojiPickerIsOpen}
      onClickedOutside={this.closeEmojiPicker}
      onInputChange={this.handleEmojiFilterChange}
    >
      <EmojiPicker
        onEmojiPicked={this._handleEmojiPicked}
        filter={this.state.emojiFilter}
      />
    </PopupWindow>
  )

  _renderUserPopup = () => (
    <UserPopupWindow
      isOpen={this.state.userPickerIsOpen}
      onClickedOutside={this.closeUserPicker}
      onInputChange={this.handleUserFilterChange}
    >
      <UserPicker
        onuserPicked={this._handleUserPicked}
        filter={this.state.userFilter}
        message={this.state.userInputfilter}
      />
    </UserPopupWindow>
  )

  _renderSendOrFileIcon() {
    // if (this.state.inputHasText) {
    if (this.state.editorState) {
      return (
        <div className="sc-user-input--button">
          <SendIcon onClick={this._submitText.bind(this)} />
        </div>
      );
    }
    return (
      <div className="sc-user-input--button">
        <FileIcon onClick={this._showFilePicker.bind(this)} />
        <input
          type="file"
          name="files[]"
          multiple
          ref={(e) => { this._fileUploadButton = e; }}
          onChange={this._onFilesSelected.bind(this)}
        />
      </div>
    );
  }

  // keybord Enter Key Pressed
  handleReturn(event) {
    if (event.keyCode === 13 && event.shiftKey) {
    }
    else if (event.keyCode === 13) {
      var content = this.state.editorState.getCurrentContent().getPlainText()
      if (this.state.viewProjecturl !== "" && (content.includes("/Param") || this.state.SelectedClusterId !== "")) {
        this.ConfirmSubmitJob();
      } else {
        this.handleEnterKeyPressAction(event);
      }
      return 'handled';
    }
  }

  // Submit button
  handleSubmit(e) {
    e.preventDefault();
    var content = this.state.editorState.getCurrentContent().getPlainText()
    if (this.state.viewProjecturl !== "" && (content.includes("/Param") || this.state.SelectedClusterId !== "")) {
      this.ConfirmSubmitJob();
    } else {
      this.handleEnterKeyAction();
    }
  }

  checkwithNewJobFormat = () => {
    var content = this.state.editorState.getCurrentContent().getPlainText()
    if (content.includes("/Param") || content.includes("/Cluster")) {
      return true;
    } else {
      return false
    }
  }

  handleEnterKeyPressAction = (event) => {
    //  if (!event.shiftKey) {
    const content = this.state.editorState.getCurrentContent();
    // console.log('content',draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())));
    const isEditorEmpty = !content.hasText();
    const currentPlainText = content.getPlainText()
    // const lengthOfEditorContent = currentPlainText.length;
    const lengthOfTrimmedContent = currentPlainText.trim().length;
    const isContainOnlySpaces = !isEditorEmpty && !lengthOfTrimmedContent;
    if (isEditorEmpty === false && isContainOnlySpaces === false) {
      this.state.htmltxt = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
      this.state.msgd = this.state.htmltxt;
      if (this.state.viewProjecturl !== "" && this.checkwithNewJobFormat()) {
        // console.log(this.state.msgd+"----------"+'<a href='+this.state.viewProjecturl+'>'+this.state.msgd+'</a>')
        this._submitText('<a href=' + this.state.viewProjecturl + '>' + this.state.msgd + '</a>');
        this.state.viewProjecturl = "";
      } else {
        this._submitText(this.state.msgd);
        this.state.viewProjecturl = "";
      }

      if (this.state.files.length !== 0) {
        this.state.htmltxt = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
        this.state.msgd = this.state.htmltxt;
        this._submitText(this.state.msgd)
      }
    }

    //  return 'handled';
    // }
    //  return 'not-handled';
  }

  handleEnterKeyAction = () => {
    // const msgdata = {
    //      content: this.state.editorState.getCurrentContent().getPlainText()
    //     };
    const content = this.state.editorState.getCurrentContent();
    const isEditorEmpty = !content.hasText();
    const currentPlainText = content.getPlainText()
    //   const lengthOfEditorContent = currentPlainText.length;
    const lengthOfTrimmedContent = currentPlainText.trim().length;
    const isContainOnlySpaces = !isEditorEmpty && !lengthOfTrimmedContent;
    if (isEditorEmpty === false && isContainOnlySpaces === false) {
      this.state.htmltxt = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
      this.state.msgd = this.state.htmltxt;
      if (this.state.viewProjecturl !== "" && this.checkwithNewJobFormat()) {
        // console.log(this.state.msgd+"----------"+'<a href='+this.state.viewProjecturl+'>'+this.state.msgd+'</a>')
        // let msUrl = this.state.viewProjecturl;
        this._submitText('<a href=' + this.state.viewProjecturl + '>' + this.state.msgd + '</a>');
        this.state.viewProjecturl = "";
      } else {
        this._submitText(this.state.msgd);
        this.state.viewProjecturl = "";
      }
    }
    if (this.state.files.length !== 0) {
      this.state.htmltxt = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
      this.state.msgd = this.state.htmltxt;
      this._submitText(this.state.msgd)
    }

  }

  KeyBindingFn = (e) => {
    if (e.keyCode === 8 /* `if enter backspace */) {
      var editValue = this.state.editorState.getCurrentContent().getPlainText();
      if (editValue.includes("/Param") || editValue.includes("/Cluster")) {
        this.state.mentionsConfig = [];
        this.state.mentionsConfig.push({
          name: "Param"
        }, {
          name: "Cluster"
        })
      }
    }
  }

  _submitText(event) {
    this.setState({ mentionsConfig: [] })
    this.userInput = event;
    const text = event;
    // const text =  <span className="chatspan" dangerouslySetInnerHTML={{ __html: linkifyHtml(this.state.msgd) }}></span>;
    let emailList = [];
    for (let i = 0; i < this.state.input_userEmail.length; i++) {
      emailList.push(this.state.input_userEmail[i].email);
    }
    let postMsgtype = this.state.files !== 0 ? "media" : "text";
    if (text && text.length > 0) {
      this.props.onSubmit({
        author: 'me',
        type: postMsgtype,
        data: text,
        emails: emailList,
        mediaBase64Content: this.state.base64Data,
        files: this.state.files
      });
      const txt = ''
      this.state.input_userEmail = [];
      this.state.files = [];
      this.state.editorCount = 0;
      this.state.flagEditor = false;
      this.state.hasFocus = false;
      this.state.SelectedClusterId = "";
      this.state.SelectedClusterName = "";
      const contentState = ContentState.createFromText(txt);
      const editorState = EditorState.push(this.state.editorState, contentState);
      const oldEditorState = EditorState.push(this.state.oldEditorState, contentState);
      this.setState({ editorState, oldEditorState });
    }
  }
  handleAddRow = () => {
    if (this.state.parametersTablesdata.length !== 0) {
      let parsedJSON = this.state.parametersTablesdata.length - 1;
      let lastkeyRow = this.state.parametersTablesdata[parsedJSON].key;
      let lastvalueRow = this.state.parametersTablesdata[parsedJSON].value;
      if (lastkeyRow === "" && lastvalueRow === "") {
        // console.log('empty row')
      }
      else {
        const item = {
          key: "",
          value: ""
        };
        this.setState({
          parametersTablesdata: [...this.state.parametersTablesdata, item],
        });
      }
      this.ConstructParameterTable(this.state.parametersTablesdata)
    }
    else {
      const item = {
        key: "",
        value: ""
      };
      this.setState({
        parametersTablesdata: [...this.state.parametersTablesdata, item],
      });
      this.ConstructParameterTable(this.state.parametersTablesdata)
    }

  }
  // Delete Parameter Row
  handleDeleteRow = (index) => {
    this.setState({ deleteParameter: true, deleteindex: index })
  }

  confirmDeleteRows = (index) => {
    const rows = [...this.state.parametersTablesdata]
    rows.splice(index, 1)
    this.setState({ parametersTablesdata: rows })
    this.ConstructParameterTable(rows)
    this.setState({ deleteParameter: false })

  }
  CloseDeleteParameterModal = () => {
    this.setState({
      deleteParameter: false,
    })
  }

  render() {
    const { inputActive } = this.state;
    const { EmojiSuggestions, EmojiSelect } = emojiPlugin;
    const MentionSuggestions = this.mentionPlugin.MentionSuggestions;
    const MentionSuggestionsJob = this.mentionPlugin2.MentionSuggestions;
    const MentionSuggestionsProject = this.mentionPlugin3.MentionSuggestions;
    const MentionSuggestionsConfig = this.mentionPlugin4.MentionSuggestions;
    const plugins = [this.mentionPlugin, this.mentionPlugin2, this.mentionPlugin3, this.mentionPlugin4, toolbarPlugin, linkifyPlugin, emojiPlugin, imagePlugin];

    return (
      <form className={`sc-user-input editorBox ${(inputActive ? 'active' : '')}`}>
        <Card style={{ marginBottom: "0px" }}>

          {/* <div className={editorStyles.editor} onClick={this.focus}> */}
          <div className={editorStyles.editor} onFocus={() => this.setState({ hasFocus: true })}>

            <div>
              <MentionSuggestions
                style={{ overflowY: `auto`, width: "25%" }}
                onSearchChange={this.onSearchChange}
                onOpen={() => this.setState({ hideProjectPopup: false })}
                suggestions={this.state.mentionList1}
                entryComponent={Entry}
                onAddMention={this.onAddMention}
                onClose={() => this.setState({ ...this, suggestions: fromJS([]) })}
              // ref={(element) => { this.editor = element; }}
              />
              <MentionSuggestionsJob
                style={{ overflowY: `auto` }}
                onScroll={this.handleScrollRuns}
                onOpen={() => this.setState({ hideProjectPopup: true })}
                onClose={() => this.setState({ hideProjectPopup: false })}
                onSearchChange={this.onSearchChange2}
                suggestions={this.state.mentionList2}
                onAddMention={this.onAddMentionJob}
                entryComponent={Entryjob}
              />

              {!this.state.hideProjectPopup && <MentionSuggestionsProject
                style={{ overflowY: `auto`, width: "25%" }}
                onSearchChange={this.onSearchChange3}
                onOpen={() => this.setState({ hideProjectPopup: false })}
                suggestions={this.state.mentionList3}
                onAddMention={this.onAddMentionProject}
                entryComponent={EntryProject}
              />}

              <MentionSuggestionsConfig
                style={{ width: 300 }}
                onSearchChange={this.onSearchChange4}
                onOpen={() => this.setState({ hideProjectPopup: false })}
                suggestions={this.state.mentionList4}
                onAddMention={this.onAddMentionConfig}
                entryComponent={EntryProjectConfig}
              />
            </div>
            <div onClick={this.EditorClick}>
              <Editor
                editorState={this.state.editorState}
                blockRendererFn={mediaBlockRenderer}
                onChange={this.onChange}
                handleReturn={this.handleReturn.bind(this)}
                plugins={plugins}
                keyBindingFn={this.KeyBindingFn.bind(this)}
                onFocus={() => this.setState({ hasFocus: true })}
                onBlur={() => this.setState({ hasFocus: false })}
              />
            </div>

            <Row className="ml-0 mr-0" style={{ background: "#f1f1f1" }}>
              <Col className='d-flex'>
                <Toolbar>
                  {
                    // may be use React.Fragment instead of div to improve perfomance after React 16
                    (externalProps) => (
                      <div>
                        <BoldButton {...externalProps} />
                        <ItalicButton {...externalProps} />
                        <UnderlineButton {...externalProps} />
                        <CodeButton {...externalProps} />
                        <UnorderedListButton {...externalProps} />
                        <OrderedListButton {...externalProps} />
                        <BlockquoteButton {...externalProps} />
                      </div>
                    )
                  }
                </Toolbar>
                <EmojiSuggestions />
                <EmojiSelect />
              </Col>

              <Col className='d-flex justify-content-end'>
                <div className="draftJsEmojiPlugin__emojiSelect__34S1B">
                  <div className="chatattachbutton mt-0 text-center">
                    <UncontrolledDropdown direction='up'>
                      <DropdownToggle
                        tag="span"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fas fa-paperclip fa-xs pt-2"></i>
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem
                          onClick={this.toggleUpload}
                        >
                          <span id='Comments'>
                            <span style={{ fontSize: '10px' }}>Add a file from..</span><br></br> <i className="fas fa-desktop mr-3" /><b>Your computer</b>
                          </span>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
                <div className="draftJsEmojiPlugin__emojiSelect__34S1B">
                  <div className={this.state.hasFocus ? "submitdiv" : "focusdiv"} >
                    <i className={this.state.hasFocus ? "focusicon fas fa-paper-plane" : "chatsubmit fas fa-paper-plane"}
                      onClick={this.handleSubmit}
                    ></i>
                  </div>
                </div>
              </Col>
            </Row>
            {/* <div className="row no-gutters float-right" style={{ backgroundColor: '#fff'}}>     
            <Toolbar>
            {
              // may be use React.Fragment instead of div to improve perfomance after React 16
              (externalProps) => (
                <div>
                  <BoldButton {...externalProps} />
                  <ItalicButton {...externalProps} />
                  <UnderlineButton {...externalProps} />
                  <CodeButton {...externalProps} />
                   <UnorderedListButton {...externalProps} />
                   <OrderedListButton {...externalProps} />
                   <BlockquoteButton {...externalProps} />
                 </div>
              )
            }
          </Toolbar>
            <EmojiSuggestions />
            <EmojiSelect />
                    
        </div> */}
          </div>

          <Modal
            centered
            className="upload-modal"
            isOpen={this.state.showUploadModal}
            toggle={this.toggleUpload}
            backdrop="static"
            returnFocusAfterClose={false}
          >
            <ModalHeader toggle={this.toggleUpload}>File Uploads</ModalHeader>
            <ModalBody>
              <FilePond ref={ref => this.pond = ref}
                allowMultiple={false}
                maxFiles={1}
                acceptedFileTypes={['image/*']}
                maxFileSize="5MB"
                server={{
                  process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                    //  return {
                    //   abort: () => {
                    //       abort();
                    //   }
                    // }
                    setTimeout(() => {
                      load(Date.now());
                    }, 1500);
                  },
                  load: (source, load) => {
                    // simulates loading a file from the server
                    fetch(source)
                      .then(res => {
                        //console.log(res);
                        return res.blob();
                      })
                      .then(blob => {
                        //console.log(blob);
                        return load(blob);
                      });
                  }
                }}
                allowFileEncode={true}
                oninit={() => this.handleInit()}
                onupdatefiles={fileItems => {
                  // Set currently active file objects to this.state
                  this.setState({
                    files: fileItems.map(fileItem => fileItem.file),
                    base64Data: fileItems[0].getFileEncodeBase64String()
                  });
                }}
              >
              </FilePond>
              <Row>
                <Col>
                  <Button color="primary" type="submit" style={{ float: "right" }} disabled={this.state.files.length === 0} size="sm" onClick={e => this.ProceedPasteImage(e)} >
                    {/*<i className={this.state.iconaction}></i>*/}
                    &nbsp;Ok</Button>
                </Col>
                <Col>
                  <Button color="primary" type="submit" size="sm" onClick={this.toggleUpload}  >
                    {/*<i className={this.state.iconaction}></i>*/}
                    &nbsp;Cancel</Button>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
          <Modal
            centered
            isOpen={this.state.showConfigModal}
            toggle={this.toggleConfig}
            backdrop="static"
            returnFocusAfterClose={false}
            style={{ width: "600px" }}
          >
            {this.state.flagMode === "project" && <ModalHeader toggle={this.toggleConfig}>Project Name: &nbsp;{this.state.projectName}</ModalHeader>}
            {this.state.flagMode === "job" && <ModalHeader toggle={this.toggleConfig}>Job Id: &nbsp;{this.state.projectId} - {this.state.projectName}</ModalHeader>}
            {/*<Scrollbars autoHeight autoHeightMax={300}>*/}
            {/* <ModalBody>
                              <Row>
                               <Col>
                                  <Input
                                                className="form-control-alternative"
                                                placeholder="Parameters"
                                                value={this.state.projectParameter}
                                                // disabled
                                                rows="8"
                                                id="textAreaParam"
                                                name="parameterSet"
                                                onChange={this.handleChangeparam} noValidate
                                                type="textarea"
                                              />
                               </Col>
                             </Row>
                          </ModalBody> */}

            <ModalBody>
              <Tabs defaultTab="Default View" onChange={(tabId) => {
                // console.log(tabId)
              }}>
                <TabList>
                  <Row>
                    <div className="col">
                      <Tab tabFor="Default View" className="add-data-tab"> Default View</Tab>
                      <Tab tabFor="Detailed View" className="add-data-tab"> Detailed View</Tab>
                    </div>
                  </Row>
                </TabList>
                <TabPanel tabId="Default View">
                  <CardBody>
                    <Table responsive className="table-hover paratbl" id="tab_logic">
                      <thead>
                        <tr>
                          <th>Variables </th>
                          <th style={{ width: "70%" }}> Values </th>
                          <th> Action </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.parametersTablesdata.map((item, index) => (
                          item.row !== false &&
                          <tr id="addr0" key={index}>
                            <td><Input
                              className="form-control-alternative breaksen variabletxt"
                              value={this.state.parametersTablesdata[index].key}
                              style={{ border: 'none', borderRadius: '5px' }}
                              id={uuidv4()}
                              name="parameterSetkey"
                              onChange={(e) => this.handleChangeparam(index, 'key', e.target.value)}
                              noValidate
                              type="text"
                            />
                            </td>
                            <td style={{ width: "80%" }}>
                              <Input
                                className="form-control-alternative valuetxt"
                                value={item.value}
                                style={{ border: 'none', borderRadius: '5px' }}
                                id={uuidv4()}
                                name="parameterSet"
                                onChange={(e) => this.handleChangeparam(index, 'value', e.target.value)}
                                noValidate
                                type="text"
                              />
                            </td>
                            <td> <div className="">
                              <div className="row">  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <UncontrolledDropdown direction={(index > 6 ? "up" : "down")}>
                                  <DropdownToggle
                                    tag="span"
                                    onClick={e => { e.preventDefault() }}
                                    style={{ color: '#007bff', cursor: 'pointer' }}
                                  >
                                    {/* <span className="actionicon" style={{ cursor: 'pointer' }} onClick={e => { e.preventDefault() }}><i className="fas fa-info-circle" title="Description"></i>&nbsp;</span> */}
                                  </DropdownToggle>
                                  <DropdownMenu
                                    persist right
                                    className="dropdown-menu-arrow"
                                  >
                                    <DropdownItem
                                      href=""
                                      onClick={e => {
                                        e.preventDefault()
                                      }}
                                    >
                                      <span>
                                        <div style={{ maxWidth: '400px' }} className="descriptiondialog">Some Description  [['Cass Freight Index-Shipments','Cass Freight Index-Expenditures','ProducerPriceIndex-Rail ranspor','Relative Importance Weight-Rail']]</div>
                                      </span>
                                    </DropdownItem>

                                  </DropdownMenu>
                                </UncontrolledDropdown>
                                <UncontrolledDropdown direction={(index > 6 ? "up" : "down")}>
                                  <DropdownToggle
                                    tag="span"
                                    onClick={e => e.preventDefault()}
                                    style={{ color: '#007bff', cursor: 'pointer' }}
                                  >
                                    <i className="fas fa-ellipsis-h"></i>
                                  </DropdownToggle>
                                  <DropdownMenu
                                    persist right
                                    className="dropdown-menu-arrow"
                                  >
                                    <DropdownItem
                                      href=""
                                      onClick={e => { e.preventDefault(); this.handleDeleteRow(index) }}
                                    >
                                      <span>
                                        <i className="fas fa-trash-alt text-red mr-3" /> Delete
                                      </span>
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </div>
                            </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                    <br></br>
                    {this.state.parametersTablesdata.length === 0 && <span style={{ color: 'darkgray', fontSize: '14px' }}>  &nbsp; No Business Levers Found</span>}

                    <i className="fas fa-plus-circle" onClick={this.handleAddRow} title="Add New Row"></i>

                  </CardBody>
                </TabPanel>
                <TabPanel tabId="Detailed View">
                  <CardBody>
                    <div>
                      <FormGroup>
                        <div onSubmit={this.getparametervalue}>
                          {/* <Input
                              className="form-control-alternative "
                              placeholder="Parameters"
                              value={this.state.parameterSet}
                              // disabled
                              rows="12"
                              style={{ maxHeight: '800px', marginTop: 28 }}
                              id="textAreaParamm"
                              name="parameterSet"
                              onChange={this.handleChangeparam} noValidate
                              type="textarea"
                            /> */}
                          <Input
                            className="form-control-alternative"
                            placeholder="Parameters"
                            value={this.state.detailedView_ParamSet}
                            rows="8"
                            style={{ maxHeight: '800px', }}
                            id="textAreaParam"
                            name="parameterSet"
                            onChange={this.handleChangeDetailedparam} noValidate
                            type="textarea"
                          />
                        </div>
                      </FormGroup>
                    </div>
                  </CardBody>
                </TabPanel>
              </Tabs>
            </ModalBody>


            <Row>
              <Col lg="4">
              </Col>
              {/*<Col lg="4" style={{textAlign: "end"}}>
                            <Button color="gray" type="submit" size="sm" onClick={e=>this.Confighide()} >
                              &nbsp;Force Close</Button>
                            </Col>*/}
              <Col lg="4">
                <Button color="primary" type="submit" disabled={this.state.projectParameter === ""} size="sm" onClick={e => this.Submitrerun(e)} >
                  {/*<i className={this.state.iconaction}></i>*/}
                  &nbsp;Ok</Button>
              </Col>
              <Col lg="4">
              </Col>
            </Row>
          </Modal>


          {/* Delete Parameter Modal */}
          <Modal isOpen={this.state.deleteParameter} toggle={this.CloseDeleteParameterModal} className="delete-modal"
            backdrop="static">
            <div className="modal-header" toggle={this.CloseDeleteParameterModal}>
              <h5 className="modal-title pull-left">Delete Row</h5>
            </div>
            <div className="reactmodalbody">
              <p> Are you sure to delete this row?</p>
              <hr className="my-1" />
              <Row style={{ maxHeight: '30px' }}>
                <Col lg="2">
                  <FormGroup>
                    <Button
                      color="primary"
                      size="sm"
                      type="submit"
                      onClick={e => this.confirmDeleteRows(this.state.deleteindex)}
                    >
                      Delete
                    </Button>
                  </FormGroup>
                </Col>
                <Col lg="2">
                  <FormGroup>
                    <Button
                      color="secondary"
                      size="sm"
                      type="submit"
                      onClick={this.CloseDeleteParameterModal}
                    >
                      Cancel
                    </Button>
                  </FormGroup>

                </Col>
              </Row>

            </div>
          </Modal>




        </Card>
      </form>
    );
  }
}

UserInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onFilesSelected: PropTypes.func.isRequired,
  showEmoji: PropTypes.bool
};

export default UserInput;